export default "__VITE_ASSET__C_q3SvW___"